const faqs = [
  {
    id: 1,
    heading: "What do I get after purchasing a template?",
    content: "You will receive the complete source code, including HTML, CSS, JavaScript, and documentation to easily set up and customize your website.",
  },
  {
    id: 2,
    heading: "Are your templates responsive?",
    content: "Yes, all our templates are fully responsive and work perfectly across mobile, tablet, and desktop devices.",
  },
  {
    id: 3,
    heading: "Can I customize the templates?",
    content: "Absolutely! Our templates are built with clean and well-structured code, making it easy to customize content, colors, and layout.",
  },
  {
    id: 4,
    heading: "Do you provide support?",
    content: "Yes, we offer email support to help you with any issues or questions related to our templates.",
  },
  {
    id: 5,
    heading: "Do I need coding knowledge to use templates?",
    content: "Basic knowledge of HTML and CSS is helpful, but our documentation makes it easy for beginners to get started.",
  },
];

export default faqs;